<template>
  <div>
    <v-app-bar flat color="transparent">
      <v-toolbar-title>
        Notifications
      </v-toolbar-title>
    </v-app-bar>
    <div class="ma-4">
      <v-container>
        <v-row>
          <v-col cols="12" md="3">
            <v-card>
              <v-card-title>Send Notification</v-card-title>
              <v-form ref="form" class="px-5 pb-5">
                <v-textarea
                  required
                  outlined
                  label="Message"
                  :rules="rules"
                  :counter="140"
                  v-model="form.message"
                  :error-messages="form.$getError('message')"
                  placeholder="Message max of 140 characters"
                ></v-textarea>
                <v-btn
                  @click="submitMessage"
                  :loading="sending"
                  :disabled="sending || !form.message"
                  color="primary"
                  >Send</v-btn
                >
              </v-form>
            </v-card>
          </v-col>
          <v-col cols="12" md="9">
            <v-simple-table>
              <thead>
                <tr>
                  <th>Message</th>
                  <th width="20%">Created at</th>
                </tr>
              </thead>
              <tbody>
                <template v-if="notifications.data.length">
                  <tr
                    v-for="notification in notifications.data"
                    :key="notification.id"
                  >
                    <td>{{ notification.message }}</td>
                    <td>{{ notification.addedDate }}</td>
                  </tr>
                </template>
              </tbody>
            </v-simple-table>
            <div v-if="paginationLength > 1" class="text-center mt-4">
              <v-pagination
                @input="pageChanged"
                :value="notifications.meta.current_page"
                :length="paginationLength"
                :total-visible="notifications.meta.per_page"
                circle
              >
              </v-pagination>
            </div>
            <v-overlay absolute :value="loading" opacity="0.1">
              <v-progress-circular
                indeterminate
                color="primary"
                size="64"
              ></v-progress-circular>
            </v-overlay>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <v-snackbar v-model="snackbar.show" right>
      {{ snackbar.message }}
      <template v-slot:action="{ attrs }">
        <v-btn text color="green" v-bind="attrs" @click="snackbar.show = false">
          Ok
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import AdminNotification from '@/models/AdminNotification'
import Form from '@/utils/form'

export default {
  data() {
    return {
      loading: false,
      sending: false,
      form: new Form({
        message: null
      }),
      notifications: {
        data: [],
        meta: {
          current_page: 1
        }
      },
      rules: [
        v => !!v || 'Message is required',
        v => (v && v.length <= 140) || 'Max 140 characters'
      ],
      snackbar: {
        show: false,
        message: null
      }
    }
  },

  methods: {
    getAdminNotifications() {
      this.loading = true

      return AdminNotification.limit(10)
        .page(parseInt(this.notifications.meta.current_page))
        .get()
        .then(response => {
          this.notifications = response
        })
        .finally(() => (this.loading = false))
    },

    submitMessage() {
      this.sending = true
      this.$api
        .post(`notifications`, this.form.$data())
        .then(response => {
          this.getAdminNotifications()
          this.showSnackbar(response.data.message)
          this.$refs.form.reset()
          this.form.$clearErrors()
        })
        .catch(err => {
          if (err.response.status === 422) {
            this.form.$setErrors({ message: err.response.data.errors.message })
          }
        })
        .finally(() => {
          this.sending = false
        })
    },

    pageChanged(page) {
      this.notifications.meta.current_page = page
      this.getAdminNotifications()
    },

    showSnackbar(message) {
      this.snackbar.message = message
      this.snackbar.show = true
    }
  },

  computed: {
    paginationLength() {
      return this.notifications.meta.last_page
    }
  },

  created() {
    this.getAdminNotifications()
  }
}
</script>
